<template>
  <div class="container">
    <el-container>
      <el-header>
        <el-row>更换手机号码</el-row>
      </el-header>
      <el-main>
        <el-row>
          <el-col :span="18" :offset="3">
            <el-steps :space="250" :active="active" align-center>
              <el-step title="身份验证"></el-step>
              <el-step title="更换手机号码"></el-step>
              <el-step title="完成"></el-step>
            </el-steps>
          </el-col>
        </el-row>
        <div v-if="active == 0">
          <el-row class="mar-top-30">
            <el-col :span="8" :offset="9">
              <span>已绑定的手机号码：{{ phone }}</span>
            </el-col>
          </el-row>
          <el-row class="mar-top-30">
            <el-col class="flex-row-plus" :span="5" :offset="8">
              <el-input class="codeipt" v-model="verifyCode" placeholder="验证码"></el-input>
            </el-col>
            <el-col class="flex-row-plus" :span="3">
              <el-button
                v-if="isoldCodeShow"
                class="codebut"
                @click="getoldCode"
                >{{ oldcodeText }}</el-button
              >
              <el-button v-else class="codebut">{{
                oldcodeText
              }}</el-button>
            </el-col>
          </el-row>
          <el-row class="mar-top-30">
            <el-col class="flex-row-plus" :span="4" :offset="10">
              <el-button class="submitBut" @click="checkUser" type="primary"
                >下一步</el-button
              >
            </el-col>
          </el-row>
        </div>
        <div v-if="active == 1">
          <el-row class="mar-top-30">
            <el-col :span="8" :offset="8">
              <el-input class="codeipt" type="number" v-model="iphoneNum" placeholder="输入新号码" maxlength="11"></el-input>
            </el-col>
          </el-row>
          <el-row class="mar-top-30">
            <el-col class="flex-row-plus" :span="5" :offset="8">
              <el-input class="codeipt" type="number" v-model="code" placeholder="验证码"></el-input>
            </el-col>
            <el-col class="flex-row-plus" :span="3">
              <el-button
                v-if="isCodeShow"
                class="codebut"
                @click="getCode"
                >{{ codeText }} </el-button
              >
              <el-button v-else class="codebut" type="primary">{{
                codeText
              }}</el-button>
            </el-col>
          </el-row>
          <el-row class="mar-top-30">
            <el-col class="flex-row-plus" :span="4" :offset="10">
              <el-button class="submitBut" @click="updatePhone" type="primary" v-throttle
                >提交</el-button
              >
            </el-col>
          </el-row>
        </div>
        <div v-if="active == 2" style="margin:70px 0">
          <el-row>
            <el-col :span="8" :offset="8" style="text-align:center;margin-bottom:20px;">
              <img class="finishImg" src="../../../../static/image/wancheng@2x.png" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="8" style="text-align:center;">
              <span>恭喜您，更换手机已完成！</span>
            </el-col>
          </el-row>
        </div>
      </el-main>
      <el-footer class="mar-top-50">
        <el-row class="flex-column-plus mar-20-30">
          <span class="fs8">安全服务提示</span>
          <span class="mar-top-20 fs7 font-color-9A9"
            >•
            绑定手机可提高帐号安全性</span
          >
          <span class="mar-top-10 fs7 font-color-9A9"
            >• 一个手机号只能绑定一个帐号</span
          >
        </el-row>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import api from '../../../api'
import {listSearchMixin} from '../../../config/mixin'
import {mapGetters,mapMutations} from 'vuex'
export default {
  mixins: [listSearchMixin],
  data () {
    return {
      active: 0,
      iphoneNum: '',
      code: '',
      codeText: '获取验证码',
      time: 60,
      isCodeShow: true,
      isoldCodeShow: true,
      verifyCode: '',
      oldcodeText: '获取验证码',
      oldtime: 60,
      verifyIphone: '',
      phone: ''
    }
  },
  computed: {
    ...mapGetters([
      'userInfo' // 用户信息
    ])
  },
  created () {
    if (this.userInfo.phone) {
      this.verifyIphone = this.userInfo.phone
    }
    this.phone = this.verifyIphone.substr(0, 3) + '****' + this.verifyIphone.substr(7, this.verifyIphone.split('').length)
  },
  methods: {
	  ...mapMutations({
	    setUserInfo: 'SET_USERINFO', // 修改用户信息
	  }),
    // 获取更换手机号的验证码
    getCode () {
      let self = this
      let params = {
        url: api.vCode,
        method: 'POST',
        data: {
          phone:this.iphoneNum,
          type:"bind"
        }
      }
      self.sendReq(params, (res) => {
        if (res.success) {
          self.$message({
            message: '验证码获取成功',
            type: 'success'
          })
          self.timer()
        } else {
                self.$message({
                    message: res.msg,
                    type: 'warning'
                })
            }
      })
    },
    // 身份验证
    checkUser () {
      let self = this
      if (self.verifyCode === '') {
        self.$message({
          message: '验证码不能为空',
          type: 'warning'
        })
        return
      }
      let params = {
        url: api.checkUser + `?phone=${self.verifyIphone}&verificationCode=${self.verifyCode}`,
        method: 'GET',
        data: {
        }
      }
      self.sendReq(params, (res) => {
        if (res.success) {
          self.active = 1
        } else {
                self.$message({
                    message: res.msg,
                    type: 'warning'
                })
            }
      })
    },
    // 获取身份验证的验证码
    getoldCode () {
      let self = this
      let params = {
        // url: api.vCode,
		url: api.vCode,
        method: 'post',
        data: {
            phone:this.verifyIphone,
            type:"verification2323"
        }
      }
      self.sendReq(params, (res) => {
        if (res.success) {
          self.$message({
            message: '验证码获取成功',
            type: 'success'
          })
          self.oldtimer()
        } else {
                self.$message({
                    message: res.msg,
                    type: 'warning'
                })
            }
      })
    },
	getUserInfo () {
	  let self = this
	  let params = {
	    url: api.getUser,
	    method: 'GET'
	  }
	  self.sendReq(params, (res) => {
	    if (res.success) {
	      console.log('---1---',res.data);
	      self.setUserInfo(res.data)
	    }
	  })
	},
    // 更改手机号
    updatePhone () {
      let self = this
      // if (!(/^1[3456789]d{9}$/.test(self.iphoneNum))) {
      //   self.$message({
      //     message: '手机号格式错误请重新输入',
      //     type: 'warning'
      //   })
      //   return
      // }
      if (self.code === '') {
        self.$message({
          message: '验证码不能为空',
          type: 'warning'
        })
        return
      }
      let params = {
        url: api.updatePhone,
        method: 'post',
        data: {
          oldPhone:this.verifyIphone,
          phone: self.iphoneNum,
          verificationCode: self.code
        }
      }
      self.sendReq(params, (res) => {
        if (res.success) {
          console.log(res)
          self.active = 2
		  this.getUserInfo()
        } else {
                self.$message({
                    message: res.msg,
                    type: 'warning'
                })
            }
      })
    },
    // 获取身份验证的验证码倒计时
    timer () {
      if (this.time > 0) {
        this.time--
        this.codeText = this.time + 's'
        setTimeout(this.timer, 1000)
        this.isCodeShow = false
      } else {
        this.time = 0
        this.codeText = '获取验证码'
        this.isCodeShow = true
      }
    },
    // 获取更换手机号的验证码倒计时
    oldtimer () {
      if (this.oldtime > 0) {
        this.oldtime--
        this.oldcodeText = this.oldtime + 's'
        setTimeout(this.oldtimer, 1000)
        this.isoldCodeShow = false
      } else {
        this.oldtime = 0
        this.oldcodeText = '获取验证码'
        this.isoldCodeShow = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  box-sizing: border-box;
  border: 1px solid #E5E5E5;
  padding: 30px;
  .el-header{
    padding: 0;
  }
  .submitBut {
    width: 160px;
    background-color: #0060A5;
    border-radius: 0;
  }
  .codebut {
    padding: 13px 20px;
    width: 100%;
    text-align: center;
    background-color: #DDDDDD;
    color: #333333;
    border-radius: 0;
  }
  >>>.codeipt{
    .el-input__inner{
      border-radius: 0;
    }
  }
  .bottom-box {
    background-color: #eeeeee;
  }
  .finishImg {
    width: 66px;
    height: 66px;
    border-radius: 50%;
  }
  >>>.el-footer{
      background-color: #eee;
      height: auto !important;
  }
  .el-steps {
    max-width: 900px;
    margin: 0 auto;
    /deep/ {
      .el-step__description {
        padding-top: 12px;
      }
      .el-step__icon {
        width: 36px;
        height: 36px;
      }
      .el-step__title {
        font-size: 16px;
        line-height: 1em;
        margin-top: 14px;
      }
      .el-step__line {
        height: 6px;
        background-color: #ddd;
        top: 15px;
        left: 0;
        .el-step__line-inner{
          border-style: none;
        }
      }
      .el-step:first-of-type .el-step__line {
        width: 50%;
        left: auto;
        right: 0;
      }
      .el-step:last-of-type .el-step__line {
        display: block;
        width: 50%;
      }
      .is-finish,
      .is-process {
        color: #666;
        .el-step__line {
          background-color: #0060A5;
        }
        .el-step__icon {
          color: #fff;
          background-color: #0060A5;
          border-color: #0060A5;
        }
      }

      .is-wait {
        color: #dddddd;
        .el-step__icon {
          color: #fff;
          background-color: #dddddd;
          border-color: #dddddd;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/changeInfo/changePhone.vue